import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-secondary-500 uppercase tracking-wider mb-2">FAQ</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">常见问答</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            关于吃瓜网站线路、入口和使用的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-5">
                <h3 className="font-semibold text-foreground-900 mb-2 text-sm flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">Q</span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}